import styled from 'styled-components';

export const CategoriesWrapper = styled.div`
	padding-bottom: 24px;

	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
`;

export const CategoryChip = styled.div<{ $selected?: boolean; $disabled?: boolean; $round?: boolean }>`
	display: flex;
	align-items: center;
	background-color: ${props =>
		props.$selected ? props.theme.colors.transparent.light30 : props.theme.colors.transparent.light10};
	transition:
		background-color 0.2s ease-in-out,
		color 0.2s ease-in-out;
	border-radius: ${props => (props.$round ? '100px' : '4px')};
	padding: 6px 8px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	white-space: nowrap;
	gap: 4px;
	font-size: 14px;
	line-height: 1;
	min-height: 30px;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};
`;

export const ChipCloseIcon = styled.div<{ $visible?: boolean }>`
	display: ${props => (props.$visible ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	cursor: pointer;
	width: 12px;
	height: 12px;
	flex-shrink: 0;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
`;

export const CategoryName = styled.div`
	display: flex;
	align-items: center;
`;
